import React from 'react'
import ResumeBuilderHome from '../../../features/Public/PublicResume/ResumeBuilderHome'
import { Footer } from '../../../features/footer/footer'

const ResumeBuilderHomePage = () => {
  return (
    <>

      <ResumeBuilderHome />
      <Footer />
    </>

  )
}

export default ResumeBuilderHomePage